;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('ButtonDropdownController', ButtonDropdownController)

  /* @ngInject */
  function ButtonDropdownController ($element, $timeout) {
    activate()

    function activate () {
      $timeout(() => $element.find('.ui.dropdown').dropdown(), 300, false)
    }
  }
})()
